import omit from 'lodash/omit';

import { UPDATE_PLANS_FILTERS } from '../actions';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_PLANS_FILTERS: {
      const { field, value } = payload;
      if (value === null) {
        return omit(state, field);
      }

      return {
        ...state,
        [field]: value,
      };
    }
    default:
      return state;
  }
};
